<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Over/Under</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Publication, software art, programming language</p>
        <p>Over/Under explores the connection between weaving and programming, and the almost mystical connection between women and software writing, embedded deep in women's tradition of weaving not just threads, but networks.
        </p>
        <p>The weaving-programming connection can be represented through an equation: input + rules = output. In the case of weaving, the input is thread, the rules are the pattern, and the output is fabric. In the case of software, the input is data, the rules are the sequence, syntax, etc, and the output is data modified according to the rules. I wanted to be able to reveal the rules applied to the input through the output, by tracing back the instructions line by line. From all this came the writing of an interpreted language in Python that could receive as rules basic weaving instructions 'over' and 'under', and apply a pattern onto text.</p>
        <p>The software was developed in the context of the <a href="https://issue.xpub.nl/05/">OuNuPo Special Issue</a>, at the Piet Zwart Institute. The publication was displayed at the <a href="https://gaite-lyrique.net/evenement/grrrls-tech-zine-fair">Grrrls Tech Zine Fair</a>, at Le Gaîté Lyrique, Paris.</p>


      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/overunder/overunder.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/overunder/over_inside.png"></b-img>
      </b-col>
      <b-col md="4">
      <b-img class="img-fluid" src="media/overunder/22.png"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/overunder/instructions.png"></b-img>
      </b-col>

    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'OverUnderPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
